export function findOverflowParent(elem) {
  let parent = elem.parentNode;
  while (parent instanceof Element) {
    const parentStyle = window.getComputedStyle(parent);
    if (parentStyle.getPropertyValue('overflow-x') !== 'visible' || parentStyle.getPropertyValue('overflow-y') !== 'visible') {
      return parent;
    }
    parent = parent.parentNode;
  }
  return null;
}